<template>
	<div style="overflow-x: hidden !important">
		<div style="display: flex; flex-direction: column">
			<div class="main" :style="{ width: widthscreen }">
				<div class="header">
					<div class="header_title-container title">
						<h1>{{ $t("school-projects") }}</h1>
						<h5>{{ computedSchoolNumber }}</h5>
					</div>
					<div>
						<div class="header_actions" style="margin-top: 20px">
							<div class="header_actions-container">
								<el-input
									style="width: auto"
									:placeholder="$t('school-search')"
									v-model="search"
									@keyup.enter.native="reload"
								>
									<el-button slot="append" icon="el-icon-search" @click="reload" />
								</el-input>
							</div>
						</div>
					</div>
				</div>

				<div class="documents infinite-list-wrapper" style="overflow: auto">
					<div
						class="documents_container list"
						v-infinite-scroll="scrollLoad"
						:infinite-scroll-disabled="scrollDisabled"
						infinite-scroll-distance="50"
						style="margin-bottom: 100px"
					>
						<div
							v-for="s in schools"
							:key="s.id + '_school'"
							@click="goto(`/projects/school-projects/${s.id}`)"
							class="documents_wrapper list-item"
						>
							<div class="documents_upper">
								<div class="documents_thumb">
									<div style="display: flex; height: 100%">
										<md-icon class="md-size-5x" style="color: #000"> warehouse </md-icon>
									</div>
								</div>
							</div>
							<div class="documents_details">
								<div class="documents_details-infos">
									<div class="documents_details-title">
										{{ s.name }}
									</div>
									<div class="documents_details-subtitle">
										{{ s.code }}
									</div>
								</div>
								<div class="documents_details-infos2"></div>
							</div>
						</div>
					</div>
				</div>

				<div class="float-center">
					<div class="float-content-spinner" v-if="scrollLoading">
						<i class="el-icon-loading" />
					</div>
					<div
						class="float-content"
						v-bind:class="{
							visible: scrollNoMoreSnackbar,
							hidden: !scrollNoMoreSnackbar
						}"
					>
						<div class="float-text">
							{{ $t("no-more-schools") }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { goto } from "@/utils/utils"

export default {
	name: "SchoolProjects",

	components: {},

	data() {
		return {
			schools: [],

			schoolNumber: undefined,
			search: "",

			scrollLoading: false,
			scrollNoMoreSnackbar: false,
			scrollEnded: false,
			tilesNumber: 1,
			rowsToLoad: 4,
			loadedPages: 0,

			widthscreen: window.innerWidth
		}
	},
	created() {
		this.tilesNumber = Math.floor(this.widthscreen / 340)
		this.getSchools()
	},
	watch: {
		scrollNoMoreSnackbar() {
			if (this.scrollNoMoreSnackbar) {
				setTimeout(() => {
					this.scrollNoMoreSnackbar = false
				}, 3000)
			}
		}
	},
	computed: {
		scrollDisabled() {
			return this.scrollLoading || this.scrollEnded
		},
		computedSchoolNumber: function () {
			return this.$t("schools-counter").replace("%NUMBER%", this.schoolNumber)
		}
	},
	methods: {
		goto,
		getSchools() {
			if (!this.scrollEnded) {
				this.scrollLoading = true
				var payload = {
					value: this.search.toLowerCase(),
					pagination: {
						offset: this.loadedPages * this.tilesNumber * this.rowsToLoad,
						size: this.rowsToLoad * this.tilesNumber
					}
				}

				axios
					.post(process.env.VUE_APP_API_URL + "/api/organizations/filters", payload, {
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					})
					.then(res => {
						this.schoolNumber = res.data.count
						res.data.array.forEach(el => {
							let cfv =
								el.custom_field_values.find(e => e.custom_field.name === "codice meccanografico") || {}
							if (cfv.value)
								this.schools.push({
									id: el.id,
									name: el.name.String,
									code: cfv.value
								})
						})
						this.scrollLoading = false

						if (res.data.array.length == 0) {
							this.scrollNoMoreSnackbar = true
							this.scrollEnded = true
						}
					})
					.catch(err => {
						this.scrollLoading = false
						this.scrollNoMoreSnackbar = true
						this.scrollEnded = true
					})
			} else {
				this.scrollNoMoreSnackbar = true
			}
		},
		scrollLoad() {
			this.loadedPages++
			this.getSchools()
		},
		reload() {
			this.loadedPages = 0
			this.scrollEnded = false
			this.scrollLoading = false
			this.scrollNoMoreSnackbar = false
			this.schools = []
			this.getSchools()
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/collapse-button";

.float-content-spinner {
	width: 50px;
	height: 50px;
	font-size: 40px;
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
	padding-top: 5px;
	transform: translate(-25px);
}

.float-content {
	width: 300px;
	height: 30px;
	transform: translate(-150px);
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
}

.visible {
	visibility: visible;
	opacity: 1;
}

.hidden {
	visibility: hidden;
	opacity: 0;
	transition: visibility 0s 1s, opacity 1s linear;
}

.float-text {
	padding-top: 5px;
}
</style>
